import EmployeeDailyTimescan from '@/api/employee-daily-timescan'
import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
  ...baseState,
  date_from: moment().format('DD-MM-YYYY'),
  date_to: moment().format('DD-MM-YYYY')
}

export const getters = {
  tConvert: () => time => {
    if (time === null || time === undefined) return null
    // Check correct time format and split into components
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time]

    if (time.length > 1) {
      // If time format correct
      time = time.slice(1) // Remove full string match value
      time[5] = +time[0] < 12 ? ' AM' : ' PM' // Set AM/PM
      time[0] = +time[0] % 12 || 12 // Adjust hours
    }
    return time.join('') // return adjusted time or original string
  }
}

export const mutations = {
  ...baseMutations,
  SET_DATE_FROM(state, data) {
    state.date_from = data
  },
  SET_DATE_TO(state, data) {
    state.date_to = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        date_from: context.state.date_from,
        date_to: context.state.date_to
      },
      attributes
    )
    return EmployeeDailyTimescan.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  // Export Excel
  exportExcel(context, data) {
    data = {
      date_from: context.state.date_from,
      date_to: context.state.date_to
    }
    return EmployeeDailyTimescan.exportExcel(data)
  },
}
